import { FC } from 'react'
import CustomSelect from '../../UI/CustomSelect/CustomSelect'
import CustomInput from '../../UI/CustomInput/CustomInput'
import { DateTimePicker } from '../components/DateTimePicker'
import styles from '../EditClaimCardMainInformation.module.css'
import { arrangementTypes } from '../../../constants/constants'

interface DateTimeSectionProps {
  values: any
  dateTimeData: {
    startDateString: string
    finishDateString: string
    timeStart: Date | null
    timeFinish: Date | null
    selectedStartDate: Date
    selectedFinishDate: Date
    openStartDate: boolean
    openFinishDate: boolean
    openStartTime: boolean
    openFinishTime: boolean
    dropdownStartDataRef: React.RefObject<HTMLDivElement>
    dropdownFinishDataRef: React.RefObject<HTMLDivElement>
    dropdownStartTimeRef: React.RefObject<HTMLDivElement>
    dropdownFinishTimeRef: React.RefObject<HTMLDivElement>
    onChangeStartDate: (date: Date) => void
    onChangeFinishDate: (date: Date) => void
    handleTimeStartChange: (time: Date | null) => void
    handleTimeFinishChange: (time: Date | null) => void
    openStartDateDropDown: (e: React.MouseEvent) => void
    openFinishDateDropDown: (e: React.MouseEvent) => void
    openStartTimeDropDown: (e: React.MouseEvent) => void
    openFinishTimeDropDown: (e: React.MouseEvent) => void
  }
  handleChange: any
  setFieldValue: (field: string, value: any) => void
  customInput: JSX.Element
}

export const DateTimeSection: FC<DateTimeSectionProps> = ({
  values,
  dateTimeData,
  handleChange,
  setFieldValue,
  customInput,
}) => {
  return (
    <div className={styles.sectionBlock}>
      <div className={styles.sectionTitle}>Дата и время</div>
      <div className={styles.sectionContent}>
        <DateTimePicker
          label='Дата и время начала'
          dateString={dateTimeData.startDateString}
          time={dateTimeData.timeStart}
          selectedDate={dateTimeData.selectedStartDate}
          isOpenDate={dateTimeData.openStartDate}
          isOpenTime={dateTimeData.openStartTime}
          dateRef={dateTimeData.dropdownStartDataRef}
          timeRef={dateTimeData.dropdownStartTimeRef}
          onDateClick={dateTimeData.openStartDateDropDown}
          onTimeClick={dateTimeData.openStartTimeDropDown}
          onDateChange={dateTimeData.onChangeStartDate}
          onTimeChange={dateTimeData.handleTimeStartChange}
          setFieldValue={setFieldValue}
          dateField='dateStart'
          timeField='timeStart'
          placeholder='Дата начала'
          customInput={customInput}
        />
        <DateTimePicker
          label='Дата и время окончания'
          dateString={dateTimeData.finishDateString}
          time={dateTimeData.timeFinish}
          selectedDate={dateTimeData.selectedFinishDate}
          isOpenDate={dateTimeData.openFinishDate}
          isOpenTime={dateTimeData.openFinishTime}
          dateRef={dateTimeData.dropdownFinishDataRef}
          timeRef={dateTimeData.dropdownFinishTimeRef}
          onDateClick={dateTimeData.openFinishDateDropDown}
          onTimeClick={dateTimeData.openFinishTimeDropDown}
          onDateChange={dateTimeData.onChangeFinishDate}
          onTimeChange={dateTimeData.handleTimeFinishChange}
          setFieldValue={setFieldValue}
          dateField='dateFinish'
          timeField='timeFinish'
          placeholder='Дата окончания'
          customInput={customInput}
        />
        <div className={styles.cityBlock}>
          <div className={styles.leftBlock}>Расстановка</div>
          <div className={styles.rightBlock}>
            <CustomSelect
              name='arrangement'
              options={arrangementTypes}
              value={values.arrangement}
              onChangeOption={(option) => setFieldValue('arrangement', option)}
            />
          </div>
        </div>
        <div className={styles.guestsBlock}>
          <div className={styles.leftBlock}>Количество гостей</div>
          <div className={styles.rightBlock}>
            <CustomInput
              value={values.peopleCount}
              onChange={handleChange('peopleCount')}
              placeholder='Введите количество гостей'
            />
          </div>
        </div>
      </div>
    </div>
  )
}
